import { render, staticRenderFns } from "./ManageTemplateForm.vue?vue&type=template&id=72b71ace&scoped=true"
import script from "./ManageTemplateForm.vue?vue&type=script&lang=js"
export * from "./ManageTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b71ace",
  null
  
)

export default component.exports